import type { IconNode } from '../types';

/**
 * @name candlestick-big
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgMjJIOHYtN2MwLS42LjQtMSAxLTFoNmMuNiAwIDEgLjQgMSAxWiIgLz4KICA8cGF0aCBkPSJNMTIgMTF2MyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/candlestick-big
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const candlestickBig: IconNode = [
  ['path', { d: 'M16 22H8v-7c0-.6.4-1 1-1h6c.6 0 1 .4 1 1Z', key: '144h05' }],
  ['path', { d: 'M12 11v3', key: '1oymci' }],
];

export default candlestickBig;
